// Coffeescript transformed to Javascript via https://awsm-tools.com/code/coffee2js
// See: http://getcontenttools.com/tutorials/adding-new-tools

import ContentTools from 'ContentTools/build/content-tools.min.js';
import { coffeeExtends } from './helpers';

export const initInputField = function () {
    (function (_super) {
        coffeeExtends(InputFieldTool, _super);
        function InputFieldTool() {
            return InputFieldTool.__super__.constructor.apply(this, arguments);
        }
        ContentTools.ToolShelf.stow(InputFieldTool, 'input');
        InputFieldTool.label = 'Insert Input Field';
        InputFieldTool.icon = 'input-field';
        InputFieldTool.tagName = 'input';
        InputFieldTool.apply = (element, selection, callback) => {
            const cursor = selection.get()[0] + 1;

            const tip = element.content.substring(0, selection.get()[0]);
            const tail = element.content.substring(selection.get()[1]);
            const inputHtml = `<ipf contenteditable="false" >INPUT FIELD</ipf>&nbsp;`;
            element.content = tip.concat(inputHtml, tail);
            element.updateInnerHTML();
            element.taint();

            // Restore the selection
            selection.set(cursor + 16, cursor + 16);
            element.selection(selection);

            callback(true);
        };
        return InputFieldTool;
    })(ContentTools.Tools.LineBreak);
};
